import { AppBar, styled } from "@mui/material";

export const ThemedAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: "4px 4px 20px 3px rgb(0 0 0 / 7%)",
}));
